import { Box } from '@mui/material';

/**
 * Blueaster Capital brand logo (self-hosted wordmark image).
 * The source artwork has dark-navy lettering for light backgrounds, so on the app's
 * dark surfaces we render it as a crisp white wordmark (no background plate).
 */
export function BrandLogo({
  compact = false,
  height,
  mono = true,
}: {
  compact?: boolean;
  height?: number;
  mono?: boolean;
}) {
  const h = height ?? (compact ? 26 : 34);
  return (
    <Box
      component="img"
      src="/blueaster-logo.png"
      alt="Blueaster Capital"
      draggable={false}
      sx={{
        height: h,
        width: 'auto',
        display: 'block',
        objectFit: 'contain',
        userSelect: 'none',
        // Flatten the multi-color artwork to white so every glyph reads on dark bg.
        filter: mono
          ? 'brightness(0) invert(1) drop-shadow(0 2px 6px rgba(0,0,0,0.45))'
          : 'none',
      }}
    />
  );
}
